import React from 'react';

import {
    Show,
    ShowButton,
    SimpleShowLayout,
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    SelectInput,
    SimpleForm,
    TextInput,
    Filter,
    ReferenceInput,
    AutocompleteInput,
    ReferenceField,
    ArrayInput,
    SimpleFormIterator,
    ArrayField,
    ChipField,
    SingleFieldList,
    BooleanInput,
    FileInput,
    FileField,
    BooleanField,
} from 'react-admin';

const HumanFilter = props => (
    <Filter {...props}>
        <TextInput resettable label="이름" source="name" alwaysOn />
    </Filter>
);

export const HumanList = props => (
    <List title="백색소음 등급" {...props} 
        exporter={false}
        filters={<HumanFilter />} sort={{ field: 'id', order: 'DESC' }} mutationMode='pessimistic'>
        <Datagrid>
            <TextField source="id" />
            <TextField label="백색소음" source="name"/>
            <BooleanField label="기본 여부" source="default"/>
            <FileField label="파일" source="wav.src" title="wav.title" />
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

const HumanTitle = ({ record }) => {
    return <span>백색소음 등급 {record ? `"${record.name}"` : ''}</span>;
};

export const HumanShow = props => (
    <Show title={<HumanTitle />} {...props}>
        <SimpleShowLayout>
            <TextField label="백색소음" source="name"/>
            <BooleanField label="기본 여부" source="default"/>
            <FileField label="파일" source="wav.src" title="wav.title" />
        </SimpleShowLayout>
    </Show>
);